import React from 'react'
import "./footer.css"


function Footer() {
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/twitter-bootstrap/5.2.0/css/bootstrap.min.css"/>
  return (
    
        <div class="container-footer">
  <footer>
        <div class="container">
            <div class="row">
            
                <div class="col-lg-4 col-sm-6">
                    <div class="single-box">
                        <h2 className='titre-footer'>Contact</h2>
                    <ul>
                        <li><p>Mail: association.danceflowers@gmail.com</p></li>
                        
                        
                        
                    </ul>
                    </div>                    
                </div>
            
                <div class="col-lg-4 col-sm-6">
                    <div class="single-box">
                        <h2 className='titre-footer'>Suivez-nous</h2>
                        <p>Retrouvez-nous sur notre Facebook</p>
                       
                       
                        <p class="socials">
                        <a className='lien-fa' href='https://www.facebook.com/ADanceFlowers'>
                        <svg aria-hidden="true" focusable="false" data-prefix="fab" data-icon="facebook" class="svg-inline--fa fa-facebook fa-2x " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z"></path></svg>
</a>
                          
                        </p>
                    </div>
                </div>
             
                <small className='copyright'>Copyright © 2025 Association Dance Flowers. Tous droits réservés.</small>

            </div>
        </div>
    </footer>
</div>
    
  )
}

export default Footer